import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { SidebarService } from '../sidenav.service';
import { SideBarButton } from 'src/app/settings/nav-list/recursive-sidebar/class/sidebar';

@Component({
  selector: 'app-sidenav-btn',
  templateUrl: 'button.component.html',
  styleUrls: ['./button.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatInputModule,
    MatSidenavModule,
    NgScrollbarModule,
    MatExpansionModule,
    MatListModule,
    RouterLinkActive,
    RouterLink,
  ],
})
export class SideNavButtonComponent implements OnInit {
  @Input() button!: SideBarButton;
  @Input() extraUrl = '.';
  constructor(private sidenavService: SidebarService) {}
  ngOnInit(): void {}

  get hasChildren(): boolean {
    return this.button.butons && this.button.butons.length > 0;
  }
  getLink(): string[] {
    return this.button.data.overWriteUrl
      ? [this.button.data.overWriteUrl]
      : [this.extraUrl + this.button.data.url];
  }

  onClick(event: Event): void {
    this.sidenavService.toggleSidebar();
  }
}
